<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="closeOnClickModal"
    :destroy-on-close="destroyOnClose"
    :width="width"
    :title="title"
    :top="top"
    :before-close="handleClose"
    :close-on-press-escape="false"
    :append-to-body="appendToBody"
    class="kl-dialog"
  >
    <div slot="title" class="title">
      <slot name="title"></slot>
    </div>
    <slot></slot>
    <div slot="footer" class="dialog-footer">
      <slot name="footer">
        <el-button type="primary" plain @click="handleClose">{{ buttonArray[0] }}</el-button>
        <el-button type="primary" @click="handleSubmit">{{ buttonArray[1] }}</el-button>
      </slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'KL-Dialog',
  props: {
    top: {
      type: String,
      default: '10vh',
    },
    width: {
      type: String,
      default: '30%',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    destroyOnClose: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '标题',
    },
    buttonArray: {
      type: [Object,Array],
      default: ()=> ['取消','确定']
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleSubmit() {
      this.$emit('submit');
    },
  },
};
</script>

<style lang="scss" scoped>
.kl-dialog {
  ::v-deep.el-dialog__body {
    padding: 20px;
  }

  .title {
    font-family: PingFang-Medium;
    font-size: 16px;
  }
}
</style>
